'use strict';

var _ = require('lodash');
var GridImportCsvButtonController = function GridImportCsvButtonController($scope, $rootScope) {
  var gridPanel = $scope.gridPanelScope;
  $scope.isImportButtonShown = gridPanel.jqxGridSettings.editable;
  $scope["import"] = function () {
    var mode = _.get($scope.screenState, 'calendarMode', '');
    var scenarioName = _.get($scope.screenState, 'scenarioName', '');
    var calibrationName = _.get($scope.screenState, 'calibrationName', '');
    $rootScope.$broadcast('grid:showImportModal', $scope.gridPanelScope.gridId, mode, scenarioName, calibrationName);
  };
};
GridImportCsvButtonController.$inject = ['$scope', '$rootScope'];
module.exports = GridImportCsvButtonController;